"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantTotal = void 0;
const getTotalVariantValue_1 = require("./getTotalVariantValue");
const getVariantTotal = (variant, date) => {
    const total = (0, getTotalVariantValue_1.getTotalVariantValue)(variant, date);
    return total;
};
exports.getVariantTotal = getVariantTotal;
